import {GetDirectSaleLabourItemCalculatePriceResponse} from '@dms/api/warehouse';

import {LabourItemCurrentPrices} from '../types/LabourItemCurrentPrices';

/**
 * Maps a calculate-price response to the current prices applied to the
 * labour item edit form.
 */
export function mapToLabourItemCurrentPrices(
  result: GetDirectSaleLabourItemCalculatePriceResponse
): LabourItemCurrentPrices {
  return {
    sellingPricePerUnit: result.sellingPricePerUnit.amount,
    isCustomPrice: result.isCustomPrice,
    isDiscountEnabled: result.itemsDiscounts.isDiscountEnable,
    isDoNotApplyDiscount: result.itemsDiscounts.isDoNotApplyDiscount,
  };
}
